<template>
  <v-container>
    <TreasurersChecksList />
  </v-container>
</template>

<script>
import TreasurersChecksList from '@/components/Gl/TreasurersChecks/TreasurersChecksList.vue';

export default {
  name: 'TreasurersChecks',
  components: {
    TreasurersChecksList,
  },
};
</script>
